/**
 * 将retCode转化为对应的错误信息
 *   {Number} retCode
 * @returns {*}
 */
export default {
    /**
       * 获取错误码对应的错误信息 + retCode
       *   {Number} retCode
       * @return {*}
       */
    getRetCodeDetail(retCode) {
        if (typeof retCode === 'number') {
            return getRetCodeString(retCode);
        }
        else if (typeof retCode === 'string') {
            return retCode;
        }
        return "";
    }
};
function getRetCodeString(retCode) {
    switch (retCode) {
        case 0: return "成功";
        case 100000: return "用户账号错误！";
        case 100001: return "用户密码错误！";
        case 100002: return "参数为空！";
        case 100003: return "参数错误！";
        case 100004: return "未开通手机号码权限";
        case 100005: return "频繁重复提交！";
        case 101001: return "当前正在同步组织机构数据，不能重复执行！";
        case 101002: return "当前含有业务正在处理，请稍后执行！";
        case 101003: return "同步钉钉组织机构数据异常！";
        case 101004: return "同步组织机构数据异常！";
        case 109001: return "许可证已经过期！";
        case 109002: return "许可证无效！";
        case 101000: return "输入了不支持的数据格式！";
        case 200100: return "数据来源类型不存在";
        case 200000: return "部门名称不能为空！";
        case 200001: return "部门名称重复！";
        case 200002: return "部门下面存在用户，不能删除！";
        case 200003: return "部门主管用户不存在！";
        case 200004: return "上级部门不存在！";
        case 200005: return "修改的部门不存在！";
        case 200006: return "删除的部门不存在！";
        case 200007: return "部门parentId不能为空！";
        case 200008: return "部门ID为空";
        case 200009: return "部门下面存在子部门，不能删除！";
        case 200010: return "查询的部门不存在";
        case 200011: return "部门关联组织不允许切换";
        case 200012: return "推送钉钉部门失败";
        case 200013: return "系统检测到应用文件中的组织机构在当前系统的组织机构中不存在，应用导入后请重新配置应用权限中的授权组织";
        case 201000: return "用户账号名不能为空！";
        case 201001: return "用户账号名无效！";
        case 201002: return "用户账号已经存在！";
        case 201003: return "用户姓名不能为空！";
        case 201004: return "修改的用户不存在！";
        case 201005: return "删除的用户不存在！";
        case 201006: return "用户手机号码无效！";
        case 201007: return "用户邮箱地址无效！";
        case 201008: return "用户身份证号码无效！";
        case 201009: return "用户不存在！";
        case 201010: return "用户ID不能为空！";
        case 201011: return "用户的部门不存在！";
        case 201012: return "推送钉钉用户失败！";
        case 201012: return "用户收藏夹数据为空！";
        case 201013: return "每个用户最多保存4个最近使用应用！";
        case 201014: return "每个用户最多保设置7个常用流程！";
        case 201015: return "用户收藏夹业务类型为空！";
        case 201016: return "用户收藏夹数据已存在相同类型数据！";
        case 201017: return "用户未同步，需通知管理员同步！";
        case 201018: return "该用户已禁用，有问题请联系系统管理员！";
        case 201019: return "用户输入的密码与原密码不一致！";
        case 201020: return "新设置密码与原始密码必须不一致！";
        case 201021: return "用户手机号码未填写！";
        case 201022: return "用户手机号码已经存在！";
        case 201023: return "两次输入的密码不一致！";
        case 201024: return "员工编号已经存在！";
        case 201201: return "用户意见不存在！";
        case 201202: return "用户意见id不能为空！";
        case 201203: return "用户意见的内容不能为空！";
        case 201204: return "用户意见的用户id不一致！";
        case 201205: return "用户意见的内容长度不能超过200！";
        case 202000: return "角色名称已经存在！";
        case 202001: return "角色名称不能为空！";
        case 202002: return "角色编码已经存在！";
        case 202003: return "角色编码不能为空！";
        case 202004: return "角色主键Id已经存在！";
        case 202005: return "角色主键Id不能为空！";
        case 202006: return "角色实体不存在！";
        case 20207: return "角色下已经包含用户数据！";
        case 202008: return "角色组实体不存在！";
        case 202009: return "角色组名称不能为空！";
        case 202010: return "角色组编码不能为空！";
        case 202011: return "角色组编码已经存在！";
        case 202012: return "角色组主键Id不能为空！";
        case 202013: return "角色组下已经包含角色数据！";
        case 202014: return "角色用户实体不存在！";
        case 202015: return "角色用户主键Id不能为空！";
        case 202017: return "角色组名称已存在";
        case 202018: return "系统检测当应用文件中的角色在当前系统的角色中不存在，应用导入后请重新配置应用权限中的授权角色";
        case 300004: return "数据模型不存在！";
        case 300005: return "数据模型已经存在！";
        case 300006: return "数据模型编码无效！";
        case 300007: return "数据模型名称无效！";
        case 300008: return "发布数据模型失败！";
        case 300010: return "数据模型编码不能为空！";
        case 300011: return "数据模型名称不能为空！";
        case 300012: return "数据模型业务表生成失败！";
        case 300013: return "数据模型业务表删除失败！";
        case 300014: return "数据模型未发布";
        case 300015: return "数据模型摘要不可为空！";
        case 300016: return "数据模型%s下不存在已发布的数据项！";
        case 301001: return "数据项编码不能为空！";
        case 301002: return "数据项名称不能为空！";
        case 301003: return "数据项编码无效！";
        case 301004: return "【xx表单下xx（编码）数据项已存在】！";
        case 301005: return "数据项不存在！";
        case 301006: return "发布的数据项编码不可修改！";
        case 301007: return "子表有数据项，不可修改类型！";
        case 301008: return "数据项类型不可修改！";
        case 301009: return "移除业务表的字段失败！";
        case 301010: return "数据项名称不能超过200个字符！";
        case 301011: return "默认数据项不可修改！";
        case 301012: return "默认数据项不可删除！";
        case 301013: return "发布数据项失败！";
        case 301014: return "数据项编码不能和系统数据项相同！";
        case 301015: return "数据项的关联业务模型不能为空！";
        case 301016: return "关联表单关联的业务模型不能为空！";
        case 301017: return "关联表单关联的业务模型不存在！";
        case 301018: return "关联表单关联的列表不存在！";
        case 301019: return "关联表单多选值类型只可为动态值！";
        case 301020: return "关联表单多选所配置的业务模型不一致！";
        case 301021: return "子表映射的字段数据项类型不一致！";
        case 301104: return "数据规则不存在！";
        case 302020: return "表单编码不能为空！";
        case 302021: return "表单名称不能为空！";
        case 302022: return "表单编码无效！";
        case 302023: return "表单已存在！";
        case 302024: return "表单不存在！";
        case 302025: return "表单名称不能超过50个字符！";
        case 302026: return "表单转换发布表单视图json异常！";
        case 302027: return "表单绑定了发布状态的流程模板！";
        case 302028: return "表单绑定了列表！";
        case 302029: return "表单是默认表单！";
        case 302030: return "表单绑定了草稿状态的流程模板！";
        case 302031: return "表单id不能为空！";
        case 302032: return "表单短码不能为空！";
        case 302033: return "自定义表单不存在！";
        case 302034: return "表单未发布！";
        case 302035: return "报表不存在！";
        case 303001: return "列表不存在";
        case 303002: return "列表编码重复";
        case 303003: return "列表编码或模型编码缺失";
        case 303004: return "列表ID重复";
        case 303005: return "展示按钮数据无效";
        case 303006: return "展示列数据无效";
        case 303007: return "展示条件数据无效";
        case 303008: return "展示排序数据无效";
        case 303009: return "数据库存在无效数据，数据重复";
        case 303010: return "名称不能为空";
        case 303011: return "按钮名称不能为空";
        case 303012: return "按钮编码不能为空";
        case 303013: return "按钮编码重复";
        case 303014: return "列表ID不能为空";
        case 303015: return "条件字段名称不能为空";
        case 303016: return "条件字段编码重复";
        case 303017: return "条件字段编码不能为空";
        case 303018: return "展示字段名称不能为空";
        case 303019: return "展示字段编码不能为空";
        case 303020: return "展示字段编码重复";
        case 303021: return "排序字段名称不能为空";
        case 303022: return "排序字段编码不能为空";
        case 303023: return "排序字段编码重复";
        case 303024: return "列表绑定了流程！";
        case 303025: return "列表是默认列表！";
        case 303026: return "列表显示字段不能为空！";
        case 303027: return "查询列表显示模式为OVERRIDE时，显示字段不能为空！";
        case 303028: return "查询列表显示模式不能为空！";
        case 303029: return "列表头信息为空！";
        case 303029: return "需要更新的模型对象客户端类型不能为空！";
        case 303030: return "列表数据重新导入时参数校验失败";
        case 303031: return "列表重试时参数为空";
        case 304001: return "业务对象不存在";
        case 304002: return "业务对象id不能为空";
        case 304003: return "业务数据的审批意见不存在";
        case 304004: return "业务对象存在业务数据";
        case 304005: return "当前模型与其他模型存在关联关系！";
        case 304006: return "表单评论ID不能为空！";
        case 304007: return "表单评论数据不存在！";
        case 304008: return "当前操作用户ID不能为空！";
        case 304009: return "没有权限删除评论！";
        case 401001: return "流程不存在！";
        case 401002: return "流程已存在！";
        case 401003: return "流程id为空！";
        case 401004: return "流程编码为空！";
        case 401005: return "流程编码重复！";
        case 401006: return "流程编码不规则！";
        case 401007: return "流程名称为空！";
        case 401008: return "流程的活动节点不存在！";
        case 401009: return "流程的连接线不存在！";
        case 401010: return "流程的发布说明为空！";
        case 401011: return "节点编码为空！";
        case 401012: return "节点编码重复：";
        case 401013: return "存在多条连接线";
        case 401014: return "没有开始节点！";
        case 401023: return "开始节点数量超过1个";
        case 401015: return "没有结束节点！";
        case 401024: return "结束节点数量超过1个";
        case 401016: return "入口活动不存在！";
        case 401017: return "出口活动不存在！";
        case 401018: return "路由条件不合法";
        case 401019: return "存在进入开始活动的连接线";
        case 401020: return "存在从结束活动出发的连接线";
        case 401021: return "不存在一条从开始到结束的路径";
        case 401022: return "节点连接线不能自己连接自己";
        case 401025: return "节点没有设置参与者";
        case 401026: return "节点没有绑定表单";
        case 401027: return "存在孤立节点";
        case 401028: return "用户申请节点必填数据项未选择";
        case 401029: return "没有设置开始节点";
        case 401030: return "没有设置结束节点";
        case 401031: return "节点编码包含特殊字符";
        case 401032: return "时间格式无效";
        case 401033: return "流程还未发布！";
        case 401034: return "子流程模板编码为空";
        case 401035: return "发起节点的参与者只能是{Originator}";
        case 401036: return "发起节点的类型只能是用户活动节点";
        case 401037: return "流程实例id不能为空";
        case 401038: return "流程模板不存在用户参与活动节点类型";
        case 401039: return "驳回到指定节点的节点编码不能为空";
        case 401040: return "当前流程已经存在流程实例数据";
        case 401041: return "否决出口节点编码不能为空";
        case 401042: return "异常节点不存在！";
        case 401043: return "子流程节点绑定的流程不存在！";
        case 401044: return "流程节点的审批意见可写状态不允许多个！";
        case 401045: return "流程被绑定成发布状态流程的子流程！";
        case 401046: return "流程被绑定成了草稿状态流程的子流程！";
        case 401047: return "参与者“上一活动参与者”函数设置不合法，上一活动必须是单个用户活动节点！";
        case 401048: return "驳回操作“驳回上一步”配置错误，上一步必须是单个的用户活动节点，不允许发布，请检查！";
        case 401049: return "否决出口“驳回上一步”配置错误，上一步必须是单个的用户活动节点，不允许发布，请检查！";
        case 401050: return "审批意见控件类型的数据项勾选了多个可见，不允许发布";
        case 401051: return "开始节点连接了多个节点，不允许发布";
        case 401052: return "发起节点不允许驳回到开始";
        case 401053: return "发起节点的参与者类型不允许多人";
        case 401054: return "节点参与者不存在";
        case 401055: return "节点参与者部门不存在";
        case 401056: return "流程的活动节点编码为空！";
        case 401057: return "同意出口不能为空或0或0%";
        case 401101: return "历史流程模板不存在！";
        case 402001: return "流程发起权限id为空！";
        case 402002: return "流程发起权限不存在！";
        case 402500: return "流程实例不存在！";
        case 402501: return "待办任务不存在！";
        case 402502: return "已办任务不存在！";
        case 402503: return "任务不存在！";
        case 402504: return "流程实例状态不存在！";
        case 402505: return "Token不存在！";
        case 402506: return "流程实例状态不合法！";
        case 402507: return "流程实例id为空！";
        case 402508: return "流程实例已存在！";
        case 402509: return "当前操作不能被撤回！";
        case 402510: return "检测到有参与者参与过当前节点，不能再处理当前节点的任务";
        case 402511: return "不允许转办给自己";
        case 402512: return "不允许加签给自己";
        case 402513: return "不允许调整给自己";
        case 402514: return "参与者数量选择不能超过%s个用户";
        case 402515: return "不能协办给当前活动处理人";
        case 402516: return "前置节点任务没有完成，不能提交.";
        case 402517: return "当前任务已经撤回！";
        case 402601: return "转办说明不允许为空！";
        case 402602: return "转办(交接)人id不允许为空！";
        case 402603: return "转办(交接)id不允许为空！";
        case 403001: return "表达式不能为空";
        case 403002: return "表达式连续多个符号";
        case 403003: return "表达式缺失右括号“)”";
        case 403004: return "表达式缺失运算符";
        case 403005: return "运算符后缺少表达式";
        case 403006: return "未关闭的括号“(”";
        case 403007: return "表达式无意义";
        case 403008: return "不能支持操作符“=”";
        case 403009: return "不能支持操作符“&”";
        case 403010: return "不能支持操作符“|”";
        case 403011: return "不能支持操作符“!”";
        case 403012: return "函数%s的参数应为%s个";
        case 403013: return "未识别的表达式";
        case 403014: return "函数%s未关闭";
        case 403015: return "函数%s的第%s个参数为空";
        case 403016: return "引号“\"”未关闭";
        case 403017: return "变量符号“{”未关闭";
        case 403018: return "函数表达式中系统参数或数据项%s不存在";
        case 403019: return "表达式%s不合法";
        case 403020: return "表达式不能以运算符开始";
        case 403021: return "函数%s不存在";
        case 403022: return "函数%s的参数最少应为%s个";
        case 404001: return "流程委托重叠";
        case 404002: return "流程委托人与受托人不能相同";
        case 405000: return "流程模板格式错误";
        case 405001: return "流程发起授权用户数据不存在";
        case 405002: return "流程发起授权部门数据不存在";
        case 405005: return "流程发起授权角色数据不存在";
        case 405006: return "路由条件函数[isRoleMember]参数不存在";
        case 405007: return "路由条件函数[isMember]参数不存在";
        case 405008: return "节点设置的参与者表达式格式错误或数据不存在";
        case 405009: return "系统节点设置的业务方法不存在";
        case 405010: return "系统节点设置的业务规则不存在";
        case 405011: return "节点事件设置的业务方法不存在";
        case 405012: return "节点事件设置的业务规则不存在";
        case 405013: return "节点事件设置的消息接受人表达式格式错误或数据不存在";
        case 405014: return "节点事件设置的业务方法不存在";
        case 405015: return "节点事件设置的业务规则不存在";
        case 405016: return "节点事件设置的消息接受人表达式格式错误或数据不存在";
        case 500001: return "业务服务不存在";
        case 500002: return "业务服务编码不能为空";
        case 500003: return "业务服务名称不能为空";
        case 500004: return "业务服务名称长度不超过50";
        case 500005: return "业务服务关联适配器编码为空";
        case 500006: return "业务服务编码无效";
        case 500007: return "业务服务已存在";
        case 500008: return "适配器不存在";
        case 500009: return "适配器运行时不存在";
        case 500010: return "业务服务已绑定业务方法，不可删除";
        case 500011: return "当前业务方法请求错误，请检查引擎服务日志";
        case 500012: return "当前业务方法绑定的API需要提供正确的身份验证或者凭据（账号或者token等）";
        case 500013: return "当前业务方法绑定的API请求错误，请检查配置或者API是否存在错误";
        case 500014: return "当前业务方法绑定的API禁止访问，请检查是否客户端呢IP或Agent被服务端拒绝访问";
        case 500015: return "当前业务方法绑定的API在服务端找不到，请检查服务端是否存在该资源";
        case 500016: return "当前业务方法绑定的API方法不允许，请求中指定的请求方法不能被用于请求相应的资源";
        case 500017: return "无法解析当前业务方法绑定的API返回的结果";
        case 500018: return "由于和被请求的资源的当前状态之前存在冲突，请求无法完成";
        case 500019: return "当前业务方法绑定的API在服务器已经不可用";
        case 500020: return "当前业务方法绑定的API服务器无法处理请求附带的媒体格式";
        case 500021: return "请求太多，请稍后重试";
        case 500022: return "当前业务方法绑定的API请求格式正确，但是由于含有语义错误，无法响应";
        case 500023: return "当前业务方法绑定的API内部错误，请检查API接口";
        case 500024: return "服务器不支持当前请求所处理的某个功能";
        case 500025: return "错误的网关，请检查API的服务器配置";
        case 500026: return "当前业务方法绑定的API服务不可用，请检查API的服务器是否正常工作";
        case 500027: return "网关超时，请检查API服务器是否负载很重或者网络是否存在延迟";
        case 500028: return "服务器不支持当前业务方法绑定的API HTTP协议";
        case 500029: return "当前业务方法绑定的API方法请求超时";
        case 500101: return "业务方法名称为空";
        case 500102: return "业务方法名称长度不超过50";
        case 500103: return "业务方法编码无效";
        case 500104: return "业务方法编码为空";
        case 500105: return "业务方法已存在";
        case 500106: return "业务方法不存在";
        case 500107: return "业务方法运行的输入参数为空";
        case 500108: return "业务方法已绑定默认方法，不可删除！";
        case 500109: return "业务方法已被流程绑定，不可删除！";
        case 500110: return "业务规则不存在";
        case 500111: return "定时任务绑定业务方法不存在";
        case 501001: return "业务服务目录名称不能为空";
        case 501002: return "业务服务目录不存在";
        case 501003: return "业务服务目录下存在集成服务，不可删除！";
        case 501004: return "业务服务目录名称已存在";
        case 501005: return "业务方法绑定的URL无效";
        case 501006: return "日期格式不合法";
        case 501007: return "不支持的应用位置";
        case 501008: return "不支持的HTTP请求类型";
        case 501009: return "不支持的请求体类型";
        case 501010: return "协议适配器类型不正确";
        case 501011: return "ws解析失败";
        case 502001: return "数据库连接池不存在";
        case 502002: return "数据库连接池已存在";
        case 502003: return "数据库连接池编码无效";
        case 502004: return "数据库连接池名称不能为空";
        case 502005: return "数据库连接池ID不能为空";
        case 502006: return "数据库连接池code不能为空";
        case 502006: return "数据库连接池已经被业务服务引用";
        case 503001: return "Sql执行失败";
        case 503002: return "单条查询返回多条记录";
        case 503003: return "查询不能执行数据操作语句, 请检查返回值类型配置";
        case 503004: return "方法传入参数类型错误，请检查参数类型配置";
        case 503005: return "无效的数值，请检查输入参数是否正确";
        case 503006: return "错误的SQL语法，请检查SQL语句";
        case 503007: return "不能插入空值，请检查是否有主外键或不能为空的字段";
        case 503008: return "无效的数据访问，请检查SQL语句";
        case 510001: return "license信息为空！";
        case 550001: return "业务规则不存在";
        case 550002: return "业务规则已存在";
        case 550003: return "业务规则编码不能为空！";
        case 550004: return "业务规则id不能为空！";
        case 550005: return "业务规则逻辑节点校验失败！";
        case 550007: return "业务规则逻辑节点验证模型的数据项不存在！";
        case 550006: return "校验的数据不存在";
        case 550008: return "业务规则逻辑节点目标模型的数据项不存在！";
        case 550009: return "业务规则执行异常！";
        case 550010: return "业务规则使用的数据项不存在！";
        case 550011: return "业务规则使用GETLIST获取数据异常！";
        case 550012: return "业务规则周期执行结束时间设置不合规范！";
        case 550013: return "业务规则逻辑校验节点模型编码为空或者模型未发布！";
        case 550014: return "业务规则校验提示";
        case 550015: return "业务规则逻辑节点验证模型的数据项重复！";
        case 600001: return "应用编码重复！";
        case 600002: return "应用编码不规范！";
        case 600003: return "应用编码不能为空！";
        case 600004: return "应用ID不能为空！";
        case 600005: return "应用不存在！";
        case 600006: return "应用存在下属节点,请先删除下属节点！";
        case 6000007: return "应用名称不能为空！";
        case 6000008: return "排序没有发生变化！";
        case 6000009: return "微应用标识重复";
        case 6000010: return "集成方法id不能为空";
        case 6000011: return "集成方法名称不能为空";
        case 6000012: return "映射方法不存在";
        case 6000013: return "业务方法不存在";
        case 6000014: return "该方法只允许绑定一个集成方法";
        case 6000015: return "映射方法id不能为空";
        case 6000016: return "业务方法名称重复";
        case 6000017: return "添加应用失败，应用数量超过许可证授权数量！";
        case 6000018: return "应用被禁用";
        case 6000019: return "系统版本号不可为空";
        case 6000020: return "当前云枢版本过低，请升级至%s或更高的版本号后再导入！";
        case 600021: return "应用编码已存在,是否覆盖已存在应用编码";
        case 600022: return "【应用文件模型格式与云枢平台格式不匹配】";
        case 600023: return "【数据模型格式与云枢平台格式不匹配】";
        case 600024: return "【表单模型格式与云枢平台格式不匹配】";
        case 600025: return "【流程模型格式与云枢平台格式不匹配】";
        case 600026: return "【视图模型格式与云枢平台格式不匹配】";
        case 600027: return "【xx应用下xx业务模型编码已存在】";
        case 600028: return "多次输入重复的编码%s,请保证输入的新编码唯一";
        case 600029: return "当前登录用户没有应用导入权限";
        case 601001: return "【xx模型编码重复】";
        case 601002: return "应用编码不存在";
        case 601003: return "业务模型不存在";
        case 601004: return "应用编码不存在";
        case 601005: return "模型编码不能为空";
        case 601006: return "存在业务模型节点";
        case 601007: return "【xx模型下xx自定义页面编码重复】";
        case 601008: return "添加模型失败，模型数量超过许可证授权数量！";
        case 601009: return "用户数量超过许可证授权数量！";
        case 601010: return "无数据权限";
        case 601011: return "每个业务模型下只允许创建一个流程模板";
        case 700001: return "部分可见，组织或角色必须配置一个";
        case 700002: return "应用不能为空";
        case 700003: return "范围必须组织角色二选一";
        case 700004: return "应用权限ID不能为空！";
        case 700005: return "应用关联的权限已存在！";
        case 700006: return "应用关联的权限不存在！";
        case 700007: return "权限组不存在！";
        case 700008: return "权限组ID不能为空！";
        case 700009: return "自定义模型过滤条件不能为空！";
        case 700010: return "管理员不存在！";
        case 700011: return "管理员类型不能为空";
        case 700012: return "应用权限存在两条以上数据！";
        case 700013: return "空的模型权限对象！";
        case 700014: return "模型权限存在两条以上数据！";
        case 700015: return "管理员id不能为空！";
        case 700016: return "权限组名称不能为空！";
        case 700017: return "未配置应用权限！";
        case 700018: return "管理员类型只能为系统管理员和应用管理员！";
        case 700019: return "相同用户id的管理员已存在！";
        case 700020: return "该用户没有流程权限！";
        case 700021: return "当前用户没有数据权限！";
        case 800001: return "系统参数模型不存在！";
        case 800002: return "系统参数的id不能为空！";
        case 800003: return "系统参数编码不能为空！";
        case 800004: return "系统参数值不能为空！";
        case 800005: return "页面类型不能为空！";
        case 801001: return "系统登录日志不存在！";
        case 802001: return "异常日志不存在！";
        case 802002: return "异常日志的id不能为空！";
        case 802003: return "异常日志已修复！";
        case 803001: return "历史消息不存在！";
        case 804001: return "获取钉钉Token失败";
        case 804002: return "注册钉钉事件通知URL失败";
        case 804003: return "解密钉钉的消息失败";
        case 804004: return "加密钉钉的消息失败";
        case 804005: return "获取钉钉的用户详情失败";
        case 804006: return "获取钉钉的用户list失败";
        case 804007: return "获取钉钉部门列表失败";
        case 804008: return "获取钉钉的部门详情失败";
        case 804009: return "获取钉钉接口的角色列表失败";
        case 804010: return "钉钉集成参数未配置";
        case 804011: return "更新钉钉事件通知URL失败";
        case 804012: return "获取钉钉角色下员工列表失败";
        case 804013: return "查询钉钉事件通知URL失败";
        case 804014: return "查询钉钉学生班级列表失败";
        case 805001: return "添加的客户端已存在";
        case 805002: return "查找的客户端不存在";
        case 805003: return "更新的客户端不存在";
        case 805004: return "删除的客户端不存在";
        case 806000: return "催办内容不能为空";
        case 900001: return "待办项不存在";
        case 1000001: return "组织名称重复";
        case 1000002: return "关联组织corpId重复";
        case 1000003: return "主组织已存在";
        case 1000004: return "组织不存在";
        case 910001: return "任务所属分组不能为空";
        case 910002: return "任务名不能为空";
        case 910003: return "任务实体不存在";
        case 910004: return "任务调度时间(fireTime和corn表达式)不能同时为空";
        case 910005: return "cron表达式不合法";
        case 910006: return "callbackType不支持";
        case 910007: return "callbackUrl不能为空";
        case 910008: return "callbackUrl不是合法的url";
        case 910009: return "任务触发时间不能早于当前日期";
        case 910010: return "任务结束时间不能早于当前日期或触发时间";
        case 910011: return "任务分组下该任务名已经存在";
        case 910012: return "导出任务执行异常";
        case 910013: return "导出任务生成的文件路径，不存在文件";
        case 910014: return "结束时间不能早于当前时间";
        case 999999: return "未知错误！";
        default: return "未定义错误码" + retCode.toString();
    }
}
